var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingmore-view"},[_c('img',{staticClass:"icon-outside Rotation",attrs:{"alt":"加载中","src":_vm.iconOutside}}),_vm._v(" "),_c('img',{staticClass:"icon-inside",attrs:{"alt":"加载中","src":_vm.iconInside}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.placeholder))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b18563","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Common/loadmoreView.vue
// module id = 620
// module chunks = 46